import { z } from 'zod';
export const ToolCallSchema = z.object({
    id: z.string(),
    conversationId: z.string(),
    messageId: z.string(),
    toolName: z.string(),
    args: z.record(z.string(), z.unknown()),
    result: z.record(z.string(), z.unknown()),
    success: z.boolean(),
    error: z.string().optional(),
    durationMs: z.number().int().nonnegative().optional(),
    createdAt: z.iso.datetime()
});
